import React from 'react';

const LogoutConfirmation = ({ onConfirm, onCancel }) => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-[#23262D] text-white p-6 rounded-2xl shadow-lg w-full max-w-sm mx-auto relative">
                <button
                    onClick={onCancel}
                    className="absolute top-2 right-2 text-gray-400 hover:text-gray-500"
                >
                    <svg
                        className="w-6 h-6"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M6 18L18 6M6 6l12 12"
                        ></path>
                    </svg>
                </button>
                <div className="flex flex-col items-center space-y-4 mt-4">
                    <div className="w-12 h-12 bg-gray-700 rounded-full flex items-center justify-center">
                        <svg
                            className="w-6 h-6 text-[#00A8E8]"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M13 16h-1v-4h-1m1-4h.01M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2z"
                            ></path>
                        </svg>
                    </div>
                    <h2 className="text-xl font-semibold">Log out</h2>
                    <p className="text-[#B9B9B9] text-center">Are you sure you want to logout?</p>
                </div>
                <div className="flex justify-between mt-6">
                    <button
                        onClick={onCancel}
                        className="flex-1 py-2 text-white bg-black rounded-lg mr-2 221 transition duration-300"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={onConfirm}
                        className="flex-1 py-2 text-white bg-red-500 rounded-lg ml-2 hover:bg-red-600 transition duration-300"
                    >
                        Yes, confirm
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LogoutConfirmation;
